import { VectaIcon } from "./VectaIcon";

type Props = {
  logoWidth?: number;
  textClassName?: string;
};

/** Vecta mark + wordmark. Used in LeftPanel (desktop) and MobileBrand (mobile). */
export const VectaFull = ({
  logoWidth = 34,
  textClassName = "text-white font-bold tracking-tight text-[clamp(1.25rem,1.8vw,2.25rem)]",
}: Props) => (
  <span className="inline-flex items-center gap-0.5">
    <VectaIcon size={logoWidth} />
    <span className={textClassName}>vecta</span>
  </span>
);
